import './App.scss';

import { Button, Typography } from '@trackman/web-shared-components';

import { ErrorBoundary } from 'react-error-boundary';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import Layout from 'components/Core/Layout/Layout';
import { Outlet } from 'react-router';
import ThemeProvider from '@trackman/web-shared-components/styles/Theme';
import { useTranslation } from 'react-i18next';
import { usePageTracking } from 'hooks/usePageTracking';
import { useReportViewMode } from 'hooks/useReportViewMode';
import { reactPlugin, appInsights } from 'utilities/telemetry';

export const App = () => {
  usePageTracking();
  useReportViewMode();

  return (
    <ThemeProvider>
      <Layout>
        <ErrorBoundaryWrapper>
          <Outlet />
        </ErrorBoundaryWrapper>
      </Layout>
    </ThemeProvider>
  );
};

const ErrorFallback = () => {
  const { t } = useTranslation();

  return (
    <div className='error-boundary-info'>
      <Typography component='div' variant='h1'>
        {t('Something went wrong')}
      </Typography>
      <Button intent='primary' onClick={() => window.location.reload()}>
        {t('Reload')}
      </Button>
    </div>
  );
};

const ErrorBoundaryWrapper = ({ children }: { children: React.ReactElement }) => {
  if (appInsights) {
    return (
      <AppInsightsErrorBoundary appInsights={reactPlugin} onError={ErrorFallback}>
        {children}
      </AppInsightsErrorBoundary>
    );
  }

  return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
};

export default App;
